import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_ONLINE_MAP_TEMPLATES_ASSIGN } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import OnlinePanelAssign from '../../components/OnlinePanel/AssignTable';

export const Route = createFileRoute('/_authenticated/online_panel/assign')({
  validateSearch: (search: Record<string, unknown>) => ({
    'vehicle-id': typeof search['vehicle-id'] === 'string' ? search['vehicle-id'] : undefined,
  }),
  beforeLoad: async ({ context }) => {
    await requirePermission(
      PERMISSION_ONLINE_MAP_TEMPLATES_ASSIGN,
      ['read'],
      '/unauthorized',
      context
    );

    return {
      ...context,
      documentTitle: { segments: ['tab.online-map/assign', 'menu.onlinePanel', 'menu.settings'] },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: OnlinePanelAssignRoute,
});

function OnlinePanelAssignRoute() {
  const { 'vehicle-id': vehicleId } = Route.useSearch();

  return <OnlinePanelAssign vehicleIdFromQuery={vehicleId} />;
}
